// extracted by mini-css-extract-plugin
module.exports = {"conversation":"Conversation_conversation__28qLK","conversationImg":"Conversation_conversationImg__1DGVI","conversationName":"Conversation_conversationName__HJUR2"};